<template>
    <div id="" style="background: rgba(0,0,0,0.2);">
        <div class="container pt-2 pb-2">
            <h1 class="mt-1" style="color: #FFF; font-size: 70px; font-weight: 900">
                É rápido<br/>
                é fácil,<br/>
                é pra você!<br/>
            </h1>
            <router-link class="btn btn-danger btn-lg" to="/seja-um-parceiro">
                <b>Seja um Parceiro</b>
            </router-link>
        </div>
        <div id="content">
            <div class="container pt-1">
                <div class="row pb-2 pt-2">
                    <div class="col text-left">
                        <h2 class="info-text">
                            Sabemos o caminho para o sucesso e queremos levar você!
                        </h2>
                    </div>

                    <div class="col text-justify">
                        <p style="font-weight: 400">
                            Você, empreendedor, gostaria de expandir seu mix de produtos, mas não consegue comprar direto com a indústria, por motivo de baixo valor disponível para compra ou até mesmo por não necessitar montar grandes estoques?
                            <br/>
                            <b style="color: #c70000; font-weight: 900">Saiba que temos uma ótima oportunidade de negócio para você!</b>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .info-text {
        font-size: 34px;
        color: #777;
    }
</style>
<script>
    export default {}
</script>



// WEBPACK FOOTER //
// Home.vue?18c88c22